import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ModalService } from '@shared/components/modal';
import { EcrituresEnCoursService } from '../services/ecritures-en-cours.service';

// Quitter l'écran annule ses écritures en cours : l'utilisateur confirme s'il veut quand même partir
export const pasDEcritureEnCoursGuard: CanDeactivateFn<unknown> = () =>
  !inject(EcrituresEnCoursService).enCours() ||
  inject(ModalService).confirm({
    title: 'Enregistrement en cours',
    message: "Quitter la page peut interrompre l'enregistrement. Quitter quand même ?",
    confirmLabel: 'Quitter',
    cancelLabel: 'Rester sur la page',
    tone: 'warn',
  });
